'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtLocationUpdateConfirm', [
	function () {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				openConfirmDialog: '=pmtLocationUpdateConfirm',
				doApproveAll: '=',
				message: '<'
			},
			link: function (scope /*, element , attr*/) {
				if (!scope.message) {
					scope.message = 'Are you sure you want to update all selected locations?';
				}

				scope.approve = function () {
					scope.doApproveAll();
				};

				scope.cancel = function () {
					scope.openConfirmDialog = false;
				};
			},
			templateUrl: 'shared/location/edit/updateConfirm/pmtLocationUpdateConfirmView.html'
		};
	}
]);
